/**
 * Accessibility utilities.
 */

/**
 * Sets aria-hidden="true" on decorative FontAwesome icons that do not yet have
 * the attribute, skipping icons that are the sole content of an interactive
 * element (those must have an aria-label on their parent instead).
 *
 * Call this after each major render that injects new HTML into the DOM.
 *
 * @param {Element} [root=document.body] — subtree to scan (defaults to full body)
 */
export function hideDecorativeIcons(root = document.body) {
    if (!root) return;
    root.querySelectorAll('i[class*="fa-"]:not([aria-hidden])').forEach(icon => {
        // If the icon is the ONLY child of a button/a/label that has no text content,
        // it may be load-bearing for the label — skip it. The parent should have
        // aria-label (enforced at authoring time in index.html and Steps.js).
        const parent = icon.parentElement;
        const isInteractive = parent && (
            parent.tagName === 'BUTTON' ||
            parent.tagName === 'A' ||
            parent.tagName === 'LABEL'
        );
        const isOnlyChild = parent && parent.children.length === 1;
        const parentHasText = parent && parent.textContent.trim().length > icon.textContent.trim().length;

        if (isInteractive && isOnlyChild && !parentHasText) {
            // Solo-icon button/link without text — skip (parent needs aria-label, not aria-hidden here)
            return;
        }

        icon.setAttribute('aria-hidden', 'true');
    });
}
